import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ecology in style",
  "description": "",
  "published": "2007-01-07T00:00:00.000Z",
  "redirect_from": ["/blog/ecology-in-style/swizec/333"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Everybody loves roadsters right? Well everybody sane. And everybody likes to take care of the place we live in? Well it does seem to be the fad these days. Take a look at this `}<a parentName="p" {...{
        "href": "http://www.teslamotors.com/styling/body.php"
      }}>{`lovely beast`}</a>{`, it's so lovely I want one.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      